import * as Yup from 'yup'

import { TEXTFIELD_REQUIRED_LENGTH } from '~/common/constants'
import { phoneSchema } from '~/common/schemas'

export const validationSchema = (t) =>
  Yup.object().shape({
    code: Yup.string().required(t('form.required')),
    fullName: Yup.string().required(t('form.required')),
    username: Yup.string().required(t('form.required')),
    email: Yup.string()
      .required(t('form.required'))
      .email(t('form.validEmail'))
      .min(
        TEXTFIELD_REQUIRED_LENGTH.EMAIL.MIN,
        t('form.minLength', {
          min: TEXTFIELD_REQUIRED_LENGTH.EMAIL.MIN,
        }),
      ),
    phone: phoneSchema(t),
    dateOfBirth: Yup.date().nullable().max(new Date(), t('date.maxToday')),
    companyId: Yup.string().required(t('form.required')),
    departmentSettings: Yup.array().test({
      message: t('form.required'),
      test: (arr) => arr.length !== 0,
    }),
  })
